// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
// other
// ROUTER
import {BrowserRouter, Route, Switch} from "react-router-dom"

// MUI
import { MuiThemeProvider } from "@material-ui/core/styles"
import FlashTheme from "./components/FlashTheme.js"

// COMPONETS
// import Home from "./components/Home.js"
import Logout from "./components/Logout.js"
import Intro from "./components/Intro.js"
import IDashIntro from "./components/Dash/A/IDashIntro.js"
import Tou from "./components/Tou.js"
import Faq from "./components/Faq.js"
import FlashRankCardTests from "./components/tests/FlashRankCardTests.js"
import FlashSwipeTests from "./components/tests/FlashSwipeTests.js"
import StatementsA from "./components/A/Statements.js"
//import StatementsB from "./components/B/Statements.js"
import RankingsA from "./components/A/Rankings.js"


import RegisterA from "./components/A/Register.js"
//import RegisterB from "./components/B/Register.js"

import RatingsA from "./components/A/Ratings.js"
//import RatingsB from "./components/B/Ratings.js"

import PreviewA from "./components/A/Preview.js"
//import PreviewB from "./components/B/Preview.js"

import SubmitA from "./components/A/Submit.js"

import ContactsA from "./components/A/Contacts.js"
//import ContactsB from "./components/B/Contacts.js"

import IssuesA from "./components/A/Issues.js"
//import IssuesB from "./components/B/Issues.js"

import SummaryA from "./components/A/Summary.js"
//import SummaryB from "./components/B/Summary.js"

import SentimentA from "./components/A/Sentiment.js"

// NATIONAL
import IDashA from "./components/A/IDash.js"
//import IDashB from "./components/B/IDash.js"
import TestDashA from "./components/A/TestDash.js"

// USCD
import SDashA from "./components/A/SDash.js"

import InfoA from "./components/A/Info.js"


// context
import { AppContextProvider } from "./AppContext.js"
import JsonPreloader from "./JsonPreloader.js";
import LoadTest from "./LoadTest.js";


// LOGGING SETUP
import appConfig from "./App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<App>")
// eslint-disable-next-line
const prelog = appConfig.getLogger("App.js")

console.log("//")
console.log("// REACT VERSION = ", React.version)
console.log("//")
console.log("// process.env = ", process.env)
console.log(`// version: [${process.env.REACT_APP_VERSION}, ${process.env.REACT_APP_DEPLOYMENT}]`)
console.log("// appConfig.LOG_NAMES =", appConfig.LOG_NAMES)

class App extends Component {

    render() {
	return (
            <AppContextProvider>
              <JsonPreloader/>
              <LoadTest/>

            <MuiThemeProvider theme={FlashTheme}>
            <BrowserRouter>
              <Switch>

                <Route path="/drives/:driveSlug/info" component={InfoA}/>
                <Route path="/info" component={InfoA}/>
                
                <Route path="/logout" component={Logout}/>

                <Route path="/drives/:driveSlug/intro" component={Intro}/>
                <Route path="/intro" component={Intro}/>

                
                <Route path="/idash-intro" component={IDashIntro}/>

                <Route path="/drives/:driveSlug/tou" component={Tou}/>
                <Route path="/tou" component={Tou}/>

                <Route path="/drives/:driveSlug/faq" component={Faq}/>
                <Route path="/faq" component={Faq}/>
                
                
                <Route path="/tests" component={FlashSwipeTests}/>
                <Route path="/tests1" component={FlashRankCardTests}/>
                
                {/* new A/B/X */}


                <Route path="/drives/:driveSlug/register" component={RegisterA}/>
                <Route path="/register" component={RegisterA}/>

                
                <Route path="/drives/:driveSlug/statements" component={StatementsA}/>
                <Route path="/statements/a" component={StatementsA}/>
                <Route path="/statements" component={StatementsA}/>

                <Route path="/drives/:driveSlug/rankings" component={RankingsA}/>
                <Route path="/rankings/a" component={RankingsA}/>
                <Route path="/rankings" component={RankingsA}/>

                <Route path="/ratings/a" component={RatingsA}/>
                <Route path="/ratings" component={RatingsA}/>

                <Route path="/drives/:driveSlug/preview" component={PreviewA}/>
                <Route path="/preview/a" component={PreviewA}/>
                <Route path="/preview" component={PreviewA}/>

                <Route path="/drives/:driveSlug/sentiment" component={SentimentA}/>
                <Route path="/sentiment/a" component={SentimentA}/>
                <Route path="/sentiment" component={SentimentA}/>

                <Route path="/drives/:driveSlug/issues" component={IssuesA}/>
                <Route path="/issues/a" component={IssuesA}/>
                <Route path="/issues" component={IssuesA}/>


                <Route path="/drives/:driveSlug/summary" component={SummaryA}/>
                <Route path="/summary/a" component={SummaryA}/>
                <Route path="/summary" component={SummaryA}/>

                <Route path="/sdash/a" component={SDashA}/>
                <Route path="/sdash" component={SDashA}/>

                <Route path="/idash/a" component={IDashA}/>
                <Route path="/idash" component={IDashA}/>

                <Route path="/testdash/a" component={TestDashA}/>
                <Route path="/testdash" component={TestDashA}/>

                <Route path="/drives/:driveSlug/submit" component={SubmitA}/>
                <Route path="/submit" component={SubmitA}/>
                
                <Route path="/drives/:driveSlug/contacts" component={ContactsA}/>
                <Route path="/contacts/a" component={ContactsA}/>
                <Route path="/contacts" component={ContactsA}/>
                <Route path="/a" component={ContactsA}/>
                <Route path="/drives/:driveSlug" component={ContactsA}/>
                <Route path="/" component={ContactsA}/>
                
              </Switch>
            </BrowserRouter>
            </MuiThemeProvider>


            </AppContextProvider>
	)
    }
}

export default App;
